import * as React from "react";
const SvgFastForward24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 20,
        fill: "black",
        viewBox: "0 0 23 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12.614 2.21 11 .956V8.78l-9.427-6.6L0 1.08v17.84l1.573-1.1L11 11.22v7.825l1.614-1.256 9-7L22.629 10l-1.015-.79-9-7ZM19.37 10 13 14.955v-9.91L19.371 10ZM2 15.08V4.92L9.256 10 2 15.08Z",
      clipRule: "evenodd"
    })
  );
export default SvgFastForward24Px;
